import { useState, useEffect, useRef } from "react";

const ChatBot = ({ isOpen, closeChat }) => {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hello! I'm your school assistant. How can I help?" }
  ]);
  const [input, setInput] = useState("");
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const getBotReply = (msg) => {
    const text = msg.toLowerCase();
    if (text.includes("hi") || text.includes("hello")) return "Hello 👋! How can I help you today?";
    if (text.includes("admission")) return "Admissions for the 2026-27 session are now open! 🎓";
    if (text.includes("contact")) return "You can reach our office at +91 9999999999 📞";
    return "I'm sorry, I didn't quite get that. Could you please ask about admissions or contact details?";
  };

  const sendMessage = () => {
    if (!input.trim()) return;

    const userMsg = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");

    setTimeout(() => {
      const botMsg = { sender: "bot", text: getBotReply(input) };
      setMessages((prev) => [...prev, botMsg]);
    }, 600);
  };

  if (!isOpen) return null;

  return (
    <div className="chatbot-box">
      <div className="chatbot-header">
        <span>School Support</span>
        <button onClick={closeChat} className="fs-3">&times;</button>
      </div>

      <div className="chatbot-body">
        {messages.map((msg, i) => (
          <div key={i} className={`chat-msg ${msg.sender === "user" ? "chat-user" : "chat-bot"}`}>
            {msg.text}
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>

      <div className="chatbot-input">
        <input
          value={input}
          onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Write a message..."
        />
        <button onClick={sendMessage}>➤</button>
      </div>
    </div>
  );
};

export default ChatBot;